<template>
    <div>
        <el-form  :model="formData" ref="formRef" label-width="90px" size="mini" inline>
            <el-form-item  prop="i_gsid" :label="$t('form_company')" >{{formData.vc_gsname}}</el-form-item>
            <el-form-item  prop="f_pay" :label="$t('collectPayment_pay_balance')" >{{formData.f_remainamount+' '+$t('collectPayment_pay_renminbi')}}</el-form-item>
            <template v-if="formData.f_rate!=1">
                <el-form-item  prop="i_bzid" :label="$t('collectPayment_pay_original_currency_balance')">{{Math.round((formData.f_remainamount/formData.f_rate)*100)/100+' '+formData.vc_bzname}}</el-form-item>
<!--                <el-form-item  prop="i_bzid" :label="$t('form_currency')" >{{formData.vc_bzname}}</el-form-item>-->
                <el-form-item  prop="i_bzid" :label="$t('form_exchange_rate')" >{{formData.f_rate}}</el-form-item>
            </template>

            <div style="margin-bottom: 20px">
                <div style="color: red">{{$t('collectPayment_pay_please_enter_the_current_write_off_amount_rmb_to_adjust_the_final_difference_of_the_original_currency_exchange_rate_conversion')}}</div>
            <el-table
                     ref="table" size="mini"
                    height="290" border :data="tableData" :key="tableId"
                     :summary-method="getSummaries" show-summary
                    :highlight-current-row="true"
                    @selection-change="handleSelectionChange">
<!--                <el-table-column v-if='formData.i_hxstatus===0'  align="center" type="selection" width="50px" :selectable="isRowSelectable"></el-table-column>-->
<!--                <el-table-column  :label="$t('form_serial_number')" align="center" type="index" width="45px"></el-table-column>-->

                <el-table-column align="center" :label="$t('collectPayment_pay_customer_name')" prop="vc_khname"    show-overflow-tooltip></el-table-column>

                <el-table-column align="center" :label="$t('collectPayment_pay_funding_arrangement_number')" prop="i_id" width="100"   show-overflow-tooltip></el-table-column>
                <el-table-column align="center" :label="$t('collectPayment_pay_amount_payable')" prop="f_sqpay_total" width="120"   show-overflow-tooltip>
                    <template slot-scope="scope">
                        <div style="text-align: right">{{scope.row.f_sqpay_total}}</div>
                    </template>
                </el-table-column>
                <el-table-column align="center" :label="$t('collectPayment_pay_write_off_amount')" prop="f_pay" width="120"   show-overflow-tooltip>
                    <template slot-scope="scope">
                        <div style="text-align: right">{{scope.row.f_pay}}</div>
                    </template>
                </el-table-column>
                <el-table-column align="center" :label="$t('collectPayment_pay_this_verification_amount_original_currency')"  prop="f_hxamount" width="100"  v-if='formData.i_hxstatus===0' >
                    <template slot-scope="scope">
                        <el-input-number v-if='formData.i_hxstatus===0' class="changeinput" @change="changeybFun(scope.row,scope.$index)" :min="0" style="width: 75px" :controls="false"  size="mini" v-model="scope.row.f_hxamount" ></el-input-number>
                        <span v-else>{{scope.row.f_hxamount}}</span>
                    </template>
                </el-table-column>
                <el-table-column align="center" :label="$t('form_currency')"  prop="vc_bzname" width="60"    show-overflow-tooltip></el-table-column>
                <el-table-column align="center" :label="$t('form_exchange_rate')"  prop="f_rate" width="100"  v-if='formData.i_hxstatus===0'  show-overflow-tooltip>
                    <template slot-scope="scope">
                        <el-input-number v-if='formData.i_hxstatus===0' class="changeinput" style="width: 75px" :controls="false"  size="mini" v-model="scope.row.f_rate" ></el-input-number>
                        <span v-else>{{scope.row.f_rate}}</span>
                    </template>
                </el-table-column>
                <el-table-column align="center" :label="$t('collectPayment_pay_this_verification_amount_rmb')"  prop="f_hxamountRMB" width="100"  v-if='formData.i_hxstatus===0'  show-overflow-tooltip>
                    <template slot-scope="scope">
                        <el-input-number v-if='formData.i_hxstatus===0' class="changeinput" @change="updateFun(scope.row,scope.$index)" :min="0" style="width: 75px" :controls="false"  size="mini" v-model="scope.row.f_hxamountRMB" ></el-input-number>
                        <span v-else>{{scope.row.f_hxamountRMB}}</span>
                    </template>
                </el-table-column>
<!--                <el-table-column align="center" label="核销日期"  prop="dt_hxtime" width="120"    show-overflow-tooltip></el-table-column>-->
                <el-table-column align="center" :label="$t('collectPayment_pay_application_number')"  prop="i_sqid" width="100"    show-overflow-tooltip></el-table-column>
                <el-table-column align="center" :label="$t('collectPayment_pay_funding_arrangement_attachment')"  prop="vc_file"     show-overflow-tooltip>
                    <template slot-scope="scope">
                        <a v-if="scope.row.vc_file&&scope.row.vc_file.signfile"
                                :download="scope.row.vc_file.signfile.vc_name"
                                mce_href="#"
                                :href="file_url+'param='+encodeURI('{app:\''+baseApp+'\',i_uid:\''+i_uid+'\',token:\''+token+'\',version:\''+baseVersion+'\',fid:\''+scope.row.vc_file.signfile.vc_newname+'\'}','utf-8')">
                            <!--:herf="file"-->     {{scope.row.vc_file.signfile.vc_name}}
                        </a>
                    </template>
                </el-table-column>

                <!--                <el-table-column  width="50" :label="$t('form_operate')" align="center">-->
<!--                    <template slot="header" slot-scope="scope" >-->
<!--                        <el-button  icon="el-icon-plus"  @click="addRow"   size="mini"  type="text" ></el-button>-->
<!--                    </template>-->
<!--                    <template slot-scope="scope" >-->
<!--                        <div style="text-align: center !important;">-->
<!--                            <el-button  icon="el-icon-minus"  type="text" @click="deleteRow(scope.row,scope.$index)"  size="mini" class="mrl10" ></el-button>-->

<!--                        </div>-->
<!--                    </template>-->
<!--                </el-table-column>-->
<!--                <el-table-column align="center" label="备注" prop="vc_note" show-overflow-tooltip></el-table-column>-->
            </el-table>
            </div>
            <div class="formDiv flex jcsb">
                <el-form-item class="form-title" prop="vc_lruname" :label="$t('form_input_person')" >
                    <span>{{formData.vc_lruname}}</span>
                </el-form-item>
                <el-form-item class="form-title" prop="dt_createtime" :label="$t('form_entry_date')" >
                    <span>{{formData.dt_createtime}}</span>
                </el-form-item>
            </div>
        </el-form>
        <div slot="footer" class="dialog-footer" style="text-align: center">
            <template >
                <el-button v-if='formData.i_hxstatus===0'  type="primary" @click="saveForm" :disabled="disabled" :class="baseerp+'btn'" size="small" >{{$t('button_save')}}</el-button>
<!--                <el-button type="primary" @click="editForm" :disabled="disabled" :class="baseerp+'btn'" size="small" v-if="!canEdit">{{$t('button_edit')}}</el-button>-->
            </template>

            <el-button @click="cancel" size="small">{{$t('button_cancel')}}</el-button>

        </div>
    </div>
</template>

<script>
    import * as API from "./api"
    import {baseerp,baseApp,file_url,baseVersion} from "@/utils/baseUrl";

    export default {
        name: "DetailPage",
        components: {},
        props:{
            data:{
                type:Object,
                required:true
            }
        },
        data() {
            return {
                disabled:false,
                baseerp:'',
                token:'',
                i_uid:'',
                file_url: '',
                baseApp:"",
                baseVersion:"",
                formData:{},
                tableData:[],
                tableHeight:0,
                multipleSelection:[],
                tableId:0,

            }
        },

        watch: {
            data: {
                handler() {
                    if (this.data) {
                        this.i_id=this.data.i_id;
                        // console.log(this.i_id,'this.i_id',this.data,'this.data')
                        this.formData=JSON.parse(JSON.stringify(this.data));
                        // this.formData.dt_paytime='2025-01-02';
                        // this.formData.dt_createtime=this.getDateYYYYMMddHHMMSS();
                        // this.formData.vc_lruname=sessionStorage.getItem("lruname");
                        // this.formData.i_lruid=sessionStorage.getItem("userid");
                        if(this.formData.i_hxstatus===0) {
                            this.getPaymentApplies();
                        }else if(this.formData.i_hxstatus===1){
                            this.getPayedOrder();
                        }



                    }
                },
                immediate: true,
                deep: true
            },
            '$root.workSize':{
                handler(n,o) {
                    this.onResize(n);
                },
                deep:true,
            },
        },
        updated(){
            this.$nextTick(()=>{
                this.$refs.table.doLayout()

            })
        },
        beforeMount(){
            // this.getbzlist();

        },
        activated(){
            this.onResize();
        },
        mounted() {
            this.bzList=this.formData.bzList
            this.baseerp=baseerp;
            this.token=sessionStorage.getItem("token");
            this.i_uid= sessionStorage.getItem("userid");
            this.baseApp = baseApp;
            this.baseVersion = baseVersion;
            this.file_url = file_url;
            // this.getbzlist();
            this.$nextTick(()=>{
                this.onResize();

            })
        },
        methods: {
            onResize (n){
                if (n==undefined) n=this.$root.workSize;
                $("#homeBox").height(n.h);
                $("#homeBox").width(n.w);
                this.tableHeight= n.h-(n.h)*0.3-120;
                if(this.tableHeight<60)this.tableHeight=60;
            },
            changeybFun(row,index){
                let val=JSON.parse(JSON.stringify(row))
                let rmb=Math.round((val.f_hxamountRMB/val.f_rate)*100)/100
                if ((val.f_hxamount>=rmb-1)&&(val.f_hxamount<=rmb+1)){

                }else{
                    this.$message.warning(this.$t('collectPayment_pay_the_difference_between_the_original_currency_and_the_rmb_exchange_rate_should_be_within'))
                    val.f_hxamount=rmb
                    // this.$forceUpdate()
                }
                this.tableData[index]=val
                this.$forceUpdate()
                this.tableId=Math.random();
            },
            updateFun(row,index){
                let val=JSON.parse(JSON.stringify(row))
                val.f_hxamount=Math.round((row.f_hxamountRMB/row.f_rate)*100)/100
                this.tableData[index]=val
                this.tableId=Math.random();

                // console.log('11111111', this.tableData)
                this.$forceUpdate()
            },
            // editForm(){
            //     this.canEdit=true
            // },
            handleSelectionChange(val) {
                this.multipleSelection = val;
            },
            isRowSelectable(row,index){
                if(this.formData.i_bzid==1){
                    return true
                }else{
                    if(row.i_bzid===this.formData.i_bzid){
                        return true
                    }else{
                        return false
                    }
                }
            },
            getSummaries(param) {
                this.$nextTick(()=>{
                    this.$refs.table.doLayout()

                })
                const { columns, data } = param;
                const len = columns.length;
                const sums = [];
                columns.forEach((column, index) => {
                    // console.log(column,"column")
                    if (index === 0) {
                        sums[index] = this.$t('collectPayment_pay_total')
                    } else if (column.property=="f_hxamountRMB"||column.property=="f_hxamount"||column.property=="f_sqpay_total") {
                        const values = data.map(item => Number(item[column.property]))
                        if (!values.every(value => isNaN(value))) {
                            sums[index] = values.reduce((prev, curr) => {
                                const value = Number(curr)
                                if (!isNaN(value)) {
                                    // return (prev + curr).Math.round((prev + curr)*10000)/10000;
                                    let hj=prev + curr;
                                    // let zh=hj.toFixed(2);
                                    if (isNaN(hj)) {
                                        return;
                                    }
                                    let zh = Math.round(hj*100)/100;
                                    // console.log(zh,"zh")
                                    return zh;
                                } else {
                                    return prev
                                }
                            }, 0)
                        } else {
                            sums[index] = 'N/A'
                        }
                    } else {
                        sums[index] = ''
                    }
                })
                return sums
            },
            saveForm(){
                // let sum=0;
                // this.tableData.map((t)=>{sum=t.f_pay+sum});
                // if(this.multipleSelection.length==0){
                //     this.$message.warning('请选择数据')
                // }else{
                    let sum=this.tableData.reduce((acc,val)=>acc+val.f_hxamountRMB,0);
                    let table=this.tableData.filter(t=>t.f_hxamountRMB!=0)
                    // console.log('sum=',table)
                // return
                    if(sum > this.formData.f_remainamount){
                        this.$message.warning(this.$t('collectPayment_pay_the_total_amount_of_verification_shall_not_exceed_the_balance'))

                    }else if(sum ==0){
                        this.$message.warning(this.$t('collectPayment_pay_the_total_amount_of_verification_cannot_be'))

                    }else{
                        this.manaulProcessHx(table);
                        this.disabled=true
                    }

                // }


            },
            cancel(){
                this.$emit('close')
            },


            async manaulProcessHx(table){
                let param={
                    i_fkid:this.formData.i_id,
                    i_gsid:this.formData.i_gsid,
                    f_rate:this.formData.f_rate,
                    i_sqids:table,
                };
                let res=await API.manaulProcessHx(param);
                if ( res.code == 1 ){
                    this.$message.success(res.message)
                    this.$emit('close','save');
                    this.disabled=false
                }else if (res.code == -2) {
                    this.$router.push('/login');
                    this.$message.error(res.message);
                }else{
                    this.$message.error(res.message);
                    this.disabled=false

                }
            },

            async getPayedOrder(){
                let param={
                    i_id:this.formData.i_id,
                };
                let res=await API.getPayedOrder(param);
                if ( res.code == 1 ){
                    this.formData.i_gsid=res.data[0].i_gsid;
                    this.formData.i_bzid=res.data[0].i_bzid;
                    this.formData.vc_bzname=res.data[0].vc_bzname;
                    this.formData.vc_gsname=res.data[0].vc_gsname;
                    this.tableData=res.data;
                    this.tableData.map(t=>{
                        t.vc_file=JSON.parse(t.vc_file)
                    })
                    this.disabled=false
                }else if (res.code == -2) {
                    this.$router.push('/login');
                    this.$message.error(res.message);
                }else{
                    this.$message.error(res.message);
                    this.disabled=false

                }
            },

            //获取当天日期
            getDateYYYYMMddHHMMSS(){
                const date = new Date();
                const month = (date.getMonth() + 1).toString().padStart(2, '0');
                const strDate = date.getDate().toString().padStart(2, '0');
                return `${date.getFullYear()}-${month}-${strDate}`

            },
            async getPaymentApplies(){
                let param={
                    i_gsid:this.formData.i_gsid,
                    i_khid:this.formData.i_khid,
                };
                let res=await API.getPaymentApplies(param);
                if ( res.code == 1 ){
                    this.tableData=res.data
                    this.tableData.map(t=>{
                        let bz=this.bzList.find(bz=>bz.i_id==t.i_bzid);
                        t.f_rate=bz.f_rate
                        t.f_hxamountRMB=0
                        t.f_hxamount=0
                        t.vc_file=JSON.parse(t.vc_file)

                    })
                    // let rmb=this.tableData.reduce((acc,val)=>acc+val.f_hxamountRMB,0);
                    // let yb=this.tableData.reduce((acc,val)=>acc+val.f_hxamount,0);
                    // let yf=this.tableData.reduce((acc,val)=>acc+val.f_sqpay_total,0);
                    //
                    // this.tableData.push({
                    //     i_id:0,
                    //     vc_khname:'合计',
                    //     f_sqpay_total:yf,
                    //     f_hxamountRMB:rmb,
                    //     f_hxamount:yb,
                    // })
                }else if (res.code == -2) {
                    this.$router.push('/login');
                    this.$message.error(res.message);
                }else{
                    this.$message.error(res.message);
                }
            },
            async getbzlist(){
                let param={

                };
                let res=await API.getbzlist(param);
                if ( res.code == 1 ){
                    this.bzList=res.data.list;
                }else if (res.code == -2) {
                    this.$router.push('/login');
                    this.$message.error(res.message);
                }else{
                    this.$message.error(res.message);
                }
            },
        },
    }
</script>

<style lang="scss" scoped>
    .flex{
        display:flex;
    }
    .jcsb{
        justify-content: space-between;

    }
    /deep/.el-table .has-gutter td{
        text-align: right !important;
    }
</style>